var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-224 348.9 145.7 145",
    enableBackground: "new -224 348.9 145.7 145",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1_copy_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -218.3,
    y: 354.8,
    fill: "#0C76BC",
    width: 134,
    height: 133.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9C",
    d: "M-90.2,360.8V482h-122.1V360.8H-90.2 M-78.3,348.9h-145.9v145h145.9V348.9L-78.3,348.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCFCFB",
    points: "-196.9,417.4 -202.3,422.8 -163.9,461 -158.5,455.6 -196.9,417.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_5_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCFCFB",
    points: "-103.1,389.7 -169.4,455.6 -164,461 -97.7,395.1 -103.1,389.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFill);
export default __webpack_public_path__ + "static/media/checkbox-fill.4cfa11a3319acb61873066ea6b24104e.svg";
export { ForwardRef as ReactComponent };